<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    markRequired: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <b-form-file
    :id="fieldId"
    class="form-control"
    v-bind="$attrs"
    v-on="$listeners"
    @input="$emit('update', $event)"
  ></b-form-file>
</template>

<style lang="scss" module>
@import '@design';
</style>
